// extracted by mini-css-extract-plugin
module.exports = {"upload_des":"CoverImageUpload_style_upload_des__1q2Ar","upload_add":"CoverImageUpload_style_upload_add__3p8rR","text_desc":"CoverImageUpload_style_text_desc__3_rh5"};